import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { ButtonFloatingSize } from '@design-system/components/organisms/button-floating/entities/button-floating.types';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { NotificationSize } from '@design-system/components/molecules/notification/entities/notification.types';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { NotificationDsComponent } from '@design-system/components/molecules/notification/notification.component';

@Component({
  selector: 'app-ds-button-floating',
  templateUrl: './button-floating.component.html',
  styleUrls: ['./button-floating.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    IconDsComponent,
    TypographyDsComponent,
    NotificationDsComponent,
  ]
})
export class ButtonFloatingDsComponent {

  @Input() size = ButtonFloatingSize.RG;
  @Input() notifications = 0;
  @Input() icon: Icon;
  @Input() label: string;

  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();

  public readonly typographySizeXXS = TypographyFontSize.XXS;

  public readonly typographySemiBold = TypographyFontFamily.SemiBold;

  public readonly notificationSize = NotificationSize.MD;

  public readonly typographyColorPrimary = TypographyColor.Primary;

  public readonly iconFillColorPrimary = IconFillColor.Primary;

  constructor() { }

  get iconSize(): number {
    return this.size === ButtonFloatingSize.RG ? 20 : 16;
  }

  get notificationsAreEnabled(): boolean {
    return !!this.notifications && this.size !== ButtonFloatingSize.SM;
  }

}
